import { makeStyles, tokens } from '@fluentui/react-components';

export const useTextInputStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXS,
    // Allow the wrapped Fluent Input to shrink below its 250px default
    // min-inline-size when placed in a narrow grid cell, preventing overlap
    // with neighbouring fields at smaller desktop widths.
    minWidth: 0,
    '& .fui-Input': {
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      boxSizing: 'border-box',
    },
    '& .fui-Input__input': {
      minWidth: 0,
    },
  },
});
